export const GuardLists = {
    userAccessLogs: [],
    userInvitations: [],
    events: [],
    vehicleAccessLogs: [],
    vehicleInvitations: [],
    orders: [],
    contracts: [],
};
